import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    minHeight: 'calc(100vh - (64px + 1.5rem))',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flexStart',
    flexDirection: 'column',
    paddingTop: '1rem',
    gap: '1rem',
    width: '90vw',
    height: '100%',
    margin: '1rem',
  },
  paginationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    padding: '0.25rem 1rem 1rem',
    backgroundColor: Colors.lightGray,
    width: '100%',
  },
  
  nextButtonAnimation: {
    animation: `$fill 750ms infinite cubic-bezier(0, 1, 0, 1)`,
    transition: 'none',
  },
  
  '@keyframes fill': {
    '0%': {
      backgroundColor: Colors.primaryColor,
      color: Colors.white,
    },
    '50%': {
      backgroundColor: Colors.yellow,
      color: Colors.primaryColor,
    },
    '100%': {
      backgroundColor: Colors.primaryColor,
      color: Colors.white,
    },
  },
  
}))

export default styles
